import type { UserRoleEnum } from "@globals";

/**
 * Map of role enum values to their user-friendly display names
 */
export const roleDisplayNames = new Map<UserRoleEnum, string>([
  ["team_admin", "Team Admin"],
  ["member", "Member"],
  ["read_only", "Read Only"]
]);
